import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Data Modeling',
  content: `
In Pliable, data modeling is the backbone of your analytics workflow, enabling you to transform raw data into a structured and meaningful format. It allows you to define and organize key business concepts (entities), establish relationships between them, and create metrics that provide actionable insights.

Data modeling in Pliable covers three main areas:

- **[Entities](/docs/entities)** — Define key business concepts like Customers, Orders, or Products
- **[Metrics](/docs/metrics)** — Create calculated values derived from entity data
- **[Relationships](/docs/relationships)** — Connect entities to enable multi-dimensional reporting
`,
};

export default doc;
